import React from 'react';
import SelectChoice from './SelectChoice';
import { QuizContainer } from '../../QuizContainer';

/**
 * Https://elsevier.atlassian.net/browse/OSMS-686.
 */
const Cloze = () => {
  return (
    <QuizContainer>
      <SelectChoice />
    </QuizContainer>
  );
};

export default Cloze;
